import { render, staticRenderFns } from "./propertyType.vue?vue&type=template&id=dd792d28&"
import script from "./propertyType.vue?vue&type=script&lang=js&"
export * from "./propertyType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dd792d28')) {
      api.createRecord('dd792d28', component.options)
    } else {
      api.reload('dd792d28', component.options)
    }
    module.hot.accept("./propertyType.vue?vue&type=template&id=dd792d28&", function () {
      api.rerender('dd792d28', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/datalist/propertyType.vue"
export default component.exports